/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/internal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 */
export function formatErrorMessage(code: number, ...args: string[]): string {
  const url = new URL('https://mui.com/x/production-error');
  url.searchParams.set('code', code.toString());
  args.forEach((arg) => url.searchParams.append('args[]', arg));
  return `MUI X error #${code}; visit ${url} for the full message.`;
}
